export const DESKTOP_BREAKPOINT = 1200;
export const TABLET_BREAKPOINT = 900;
export const MOBILE_BREAKPOINT = 600;
/** Main site header (desktop + mobile); matches society public search chrome row height. */
export const NAV_HEIGHT = 52;
export const SIDEBAR_WIDTH = 240;
export const SIDEBAR_WIDTH_COLLAPSED = 64;
export const PAGE_PADDING = 24;
export const PAGE_PADDING_MOBILE = 12;
export const PAGE_PADDING_MOBILE_PUBLIC = 20;
export const PAGE_PADDING_TOP = 12;
export const HEADER_HEIGHT = 12 + 32 + 12;
export const HEADER_CONFIGURATION_HEIGHT = 12 + 56 + 12;
export const HEADER_SUB_PAGE_HEIGHT = 20 + 56 + 20 + 1 + 12;
export const TABLE_BOTTOM_PADDING = 12;
export const FOOTER_HEIGHT = 40;
export const MOBILE_FOOTER_HEIGHT = 36;
export const MOBILE_TOOLBAR_HEIGHT = 64;
export const Z_INDEX = {
  appBar: 1100,
  drawer: 1200,
  fab: 1050,
  mobileStepper: 1000,
  modal: 1300,
  snackbar: 1400,
  speedDial: 1050,
  tooltip: 1500,
};
